module.exports = __webpack_public_path__ + "img/cloud_medium.bf456ed8.svg";